import React, { useRef, useState, useEffect, useContext } from 'react'
import InputField from '../../../lib/ui/inputs/Input';
import Button from '../../../ui-styles/controls/button';
import { RxCross2 } from "react-icons/rx";
import { FiUpload } from "react-icons/fi";
import DropDown from '../../../lib/ui/dropdown/Dropdown';
import { scan, deleteS3 } from "../../../actions/appointment";
import { updateProfile } from "../../../actions/users";
import { OffLineAPI } from "../../../offline-auth/api";
import { LangCtx, PayLoadCtx } from "../../../lib/context";
import { toast } from "react-toastify";
import Loader from '../../../lib/ui/loader/Loader';
import { getSpecialization } from "../../../actions/configuration";
import DateFnsUtils from '@date-io/date-fns';
import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider,
} from '@material-ui/pickers';


const ProvisionalCertificate = (props) => {
    const { handleCloseDialog, clinic, provisionaldata, handleSaveDialog, userId, departments, degrees, specializations, setSpecializations, formData, setFormData, department, setDepartment } = props;
    const { l } = useContext(LangCtx);
    const [loading, setLoading] = useState(false);
    const [holdUploadBody, setHoldUploadBody] = useState({});
    const [error, setError] = useState({});
    const fileInputRef = useRef(null);
    const [uploadedFile, setUploadedFile] = useState([]);
    // const [formDegreeData, setFormDegreeData] = useState({ degree: "" });

    const handleChange = (e) => {
        e.persist();
        console.log("handleChange - name:", e.target.name, "value:", e.target.value); 
        setFormData((prevData) => ({
            ...prevData,
            [e.target.name]: e.target.value,
        }));
        console.log("Updated formData:"); 
        setError((prevError) => ({
            ...prevError,
            [e.target.name]: "",
        }));
    };

    const handleUploadClick = () => {
        fileInputRef.current.click();
    };
    const handleDegreeChange = (e) => {
        const { name, value } = e.target;
        console.log("handleDegreeChange - name:", name, "value:", value); 
        setFormData({ ...formData, [name]: value });
            console.log("Updated formDegreeData:", formData);
    };
    const handleSpecialization = () => {
        setLoading(true);
        let query = '';
        query = `?id=${department?.id}`;
        query = clinic ? `${query}&clinicId=${clinic}` : query ? query : '';
        getSpecialization(query).then((res) => {
            if (res.status) {
                let defaultLabel = [...res?.data];
                defaultLabel.unshift({
                    name: '',
                    label: 'Select Specialization'
                });
                setSpecializations(defaultLabel);
                setLoading(false);
            } else {
                setLoading(false);

            }
            setLoading(false);
        }).catch((err) => {
            toast.error(err?.response?.data?.error, {
                position: toast.POSITION.TOP_RIGHT
            });
            setLoading(false);

        });
    };

    const validateSpc = () => {
        console.log("specializations.length::", specializations.length)
        if (department?.id && department.id !== '' && department.value && department.value !== '' && specializations.length === 1) {
            handleSpecialization();
        }
    }

    useEffect(() => {
        validateSpc();
    }, [department]);

    const handleDropdownChange = (items, key, value) => {
        const selectedItem = items.find(item => item?.name === value);
        if (selectedItem) {
            setFormData(prev => ({
                ...prev,
                [key]: selectedItem.name,
            }));
            setError(prev => ({ ...prev, [key]: '' }));
            if (key === 'department') {
                setSpecializations([{
                    label: 'Select specialization',
                    name: ''
                }])
                setDepartment({ id: selectedItem._id, value: selectedItem.name })
                setFormData(prev => ({ ...prev, speciality: '' }));
            }
        }
    };

    const validateForm = () => {
        let _error = {};
        let isValid = true;

        if (!formData.department || formData.department.trim() === "") {
            _error["department"] = "Please select a department.";
            isValid = false;
        }
        if (!formData.speciality || formData.speciality.trim() === "") {
            _error["speciality"] = "Please select a specialization.";
            isValid = false;
        }
        if (!formData.degree || formData.degree.trim() === "") {
            _error["degree"] = "Please enter a degree.";
            isValid = false;
        }
        if (!holdUploadBody.url || !holdUploadBody.uploadkey) {
            _error["upload"] = "Please upload a document.";
            isValid = false;
        }
        if (!formData.license || formData.license.trim() === "") {
            _error["license"] = "Please provide a license authority.";
            isValid = false;
        }
        if (!formData.expirationDate) {
            _error["expirationDate"] = "Please provide a year of passing.";
            isValid = false;
        }
        console.log("Validation Errors:", _error);
        setError(_error);
        return isValid;
    };


    const handlePassingYearChange = (date) => {
        const curr_date = date ? date : new Date()
        setFormData((prevData) => ({
            ...prevData,
            expirationDate: curr_date,
        }));
    };


    const uploadOnlineOrOffline = (fileName, file) => {
        return new Promise(async (resolve, reject) => {
            let body = {
                uploadtype: file.type,
                size: file.size,
                uploadname: file.name,
            };
            if (process.env.REACT_APP_isOffline === "true") {
                const certifica_data = new FormData();
                certifica_data.append("fileData", file);
                let offlineApiPath = "";
                let urlPath = `${process.env.REACT_APP_api_server}/api/uploads/`;
                try {
                    offlineApiPath = "uploaddoctor";
                    urlPath = `${urlPath}doctorUploads`;
                    const offlineUploadRes = await OffLineAPI.upload("api", offlineApiPath, certifica_data);
                    body = {
                        ...body,
                        url: `${urlPath}/${offlineUploadRes.path}`,
                        uploadkey: offlineUploadRes.path,
                    };
                } catch (error) {
                    console.log("error", error);
                    return reject(error);
                }
            } else {
                try {
                    const certifica_data = new FormData();
                    console.log("Updated formDatasssss:", formData);

                    certifica_data.append("file", file);
                    console.log("Updated formData:", formData);
                    console.log("Contents of FormData:");
                    let params = {
                        bucket: process.env.REACT_APP_s3,
                        fileName: `public/${fileName.replace(/ /g, "_")}`,
                        region: process.env.REACT_APP_s3Region,
                    };

                    let s3UploadRes = await scan(certifica_data, params);

                    if (s3UploadRes && s3UploadRes.status) {
                        s3UploadRes = s3UploadRes.data;
                        body = {
                            ...body,
                            url:
                                `https://${process.env.REACT_APP_s3}.s3-${process.env.REACT_APP_s3Region}.amazonaws.com/` + s3UploadRes.Key,
                            uploadkey: s3UploadRes.Key,
                        };
                    } else {
                        console.log("s3UploadRes.........:)", s3UploadRes);
                        toast.error(s3UploadRes.error, {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                        resolve({});
                        // reject(s3UploadRes.error)
                    }
                } catch (error) {
                    return reject(error);
                }
            }
            return resolve(body);
        });
    };
    const handleUploadFile = async (e) => {
        console.log("File selected:", e.target.files[0]);
        if (e.target.files.length > 0) {
            const acceptedType = [".jpeg", ".jpg", ".png", ".avif", "doc", ".docx", ".pdf", ".xls", ".xlsx", ".ppt", ".pptx"];
            let file = e.target.files[0];
            console.log(file, "Selected File");
            const fileAlreadySelected =
                Array.isArray(provisionaldata) &&
                provisionaldata?.some((f) => f?.fileName?.toLowerCase() === file?.name?.toLowerCase());
            let extension = file.name.split(".").pop();

            if (fileAlreadySelected) {
                toast.dismiss();
                toast.error("File already exists");
                return;
            }

            if (file && !acceptedType.includes(`.${extension}`)) {
                toast.error("Uploaded file format not supported", {
                    position: toast.POSITION.TOP_RIGHT,
                });
            } else if (file && file.size / (1024 * 1024) < 15) {
                setLoading(true);
                try {
                    let filename = new Date().valueOf() + file.name;
                    filename = "doctorCertificates/" + filename;

                    const fileUploadResBody = await uploadOnlineOrOffline(filename, file);
                    if (Object.keys(fileUploadResBody).length <= 0) {
                        setLoading(false);
                        return;
                    }

                    setLoading(false);
                    setHoldUploadBody(fileUploadResBody);
                    setError({ ...error, upload: "" });
                    setUploadedFile((prevData) => [
                        ...(prevData || []),
                        {
                            fileName: file.name,
                            fileUploadResBody,
                        },
                    ]);

                } catch (err) {
                    setLoading(false);
                    toast.error(err.errorMessage, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                }
            } else {
                toast.error("File size should be below 15MB", {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
        } else {
            toast.error("Failed to upload the file", {
                position: toast.POSITION.TOP_RIGHT,
            });
        }
    };

    const deleteOnlineOrOfflineFile = async (url, uploadkey) => {
        setLoading(true);
        const body = {
            url: url,
            uploadkey: uploadkey,
        };
        console.log(body, "second")
        try {
            if (process.env.REACT_APP_isOffline === "true") {
                await OffLineAPI.uploadDelete("api", "/deletefile", { body });
            } else {
                let params = {
                    bucket: process.env.REACT_APP_s3,
                    fileName: holdUploadBody.uploadname,
                    region: process.env.REACT_APP_s3Region,
                };
                console.log(params)

                let s3DeleteRes = await deleteS3(params);
            }
            setLoading(false);
            toast.dismiss();
            toast.success("File removed successfully", {
                position: toast.POSITION.TOP_RIGHT,
            });
        } catch (err) {
            setLoading(false);
            console.log("error while delete file =====", err);
        }
    };
    const handleRemoveFile = async () => {
        await deleteOnlineOrOfflineFile(holdUploadBody.url, holdUploadBody.uploadkey);
        setHoldUploadBody({});
    };

    const handleUploadCertificate = async (e) => {
        e.preventDefault();
        console.log("Form data before validation:", formData);
        if (!validateForm()) {
            return
        }

        try {
            setLoading(true);
            let body;
            const newCertificate = {
                degree: formData.degree,
                department: formData.department,
                speciality: formData.speciality,
                url: holdUploadBody.url,
                key: holdUploadBody.uploadkey,
                uploadedBy: userId,
                fileName: holdUploadBody.uploadname,
                fileType: holdUploadBody.uploadtype,
                status: "pending",
                createdAt: new Date().valueOf(),
                updatedAt: new Date().valueOf(),
                licenseAuthority: formData.license,
                yearOfPassing: formData.expirationDate ? formData.expirationDate.getFullYear() : null,
            };
            console.log("Certificate data to be uploaded:", newCertificate);
            body = {
                provisionaldocuments: [newCertificate],
            };
            const res = await updateProfile(body);
            if (res.status) {
                setError({});
                toast.success("Certificate uploaded successfully!", {
                    position: toast.POSITION.TOP_RIGHT,
                });
                handleSaveDialog();
            } else {
                throw new Error(res.errorMessage || "Failed to upload certificate.");
            }
        } catch (err) {
            toast.error(err.message || "An error occurred.", {
                position: toast.POSITION.TOP_RIGHT,
            });
            console.error(err);
        } finally {
            setLoading(false);
        }
    };



    return (
        <div style={{ padding: "10px" }}>
            {loading && <Loader />}
            <div className='flexCol'>
                <span className="pdngBtm10 smallText" style={{ color: "#6F6F71" }}>
                    {l.med_lic}
                    <span className="redTxt">*</span>:
                </span>
                <div style={{ paddingBottom: "10px" }}>
                    <InputField
                        placeholder={l.med_lic}
                        value={formData.license}
                        name="license"
                        onChange={handleChange}
                        error={error && error.license}
                        errorMsg={error.license}
                        type="text"
                    />
                </div>
                <span className='pdngBtm10 smallText' style={{ color: "#6F6F71" }}>
                    Select Department
                    <span className="redTxt">*</span>:
                </span>
                <div className='pdngBtm10'>

                    <DropDown
                        placeholder={"select department"}
                        items={departments}
                        value={formData.department}
                        config='dept'
                        onChange={(e) => handleDropdownChange(departments, 'department', e.target.value)}
                        error={error && error.department}
                        errorMsg={error.department}
                    />
                </div>
                <span className='smallText pdngBtm10' style={{ color: "#6F6F71" }}>Select Specialist<span className="redTxt">*</span>:</span>
                <div className='pdngBtm10' >
                    <DropDown
                        placeholder={"select specialist"}
                        items={specializations}
                        value={formData.speciality}
                        config='spec'
                        onChange={(e) => handleDropdownChange(specializations, 'speciality', e.target.value)}
                        error={error && error.speciality}
                        errorMsg={error.speciality}
                    />
                </div>
                <span className="pdngBtm10 smallText" style={{ color: "#6F6F71" }}>
                    Year of Passing
                    <span className="redTxt">*</span>:
                </span>
                <div className= {error?.expirationDate ? "" : "pdngBtm10"}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                            fullWidth
                            className="pickerInput"
                            name="expirationDate"
                            inputVariant="outlined"
                            value={formData.expirationDate || new Date()}
                            onChange={handlePassingYearChange}
                            animateYearScrolling
                            placeholderText={l.dob}
                            format="dd/MM/yyyy"
                        // minDate={new Date()}
                        />
                    </MuiPickersUtilsProvider>
                </div>
                {error?.expirationDate && <span style={{ color: "red", fontSize: "12px", paddingBottom: "10px"}}>{error?.expirationDate}</span>}
                <span className='smallText pdngBtm10' style={{ color: "#6F6F71" }}>Degree<span className="redTxt">*</span>:</span>
                <div style={{ paddingBottom: "10px" }}>
                    <InputField
                        name="degree"
                        value={formData.degree}
                        type="text"
                        onChange={handleDegreeChange}
                        placeholder="Enter degree"
                        error={error && error.degree}
                        errorMsg={error.degree}
                    />
                </div>
                <span className="pdngBtm10 smallText" style={{ color: "#6F6F71" }}>
                    {l.upload_certificate}
                    <span className="redTxt">*</span>:
                </span>
                {holdUploadBody.url ? (
                    <div
                        className='flexRow alignCenter'
                        style={{
                            padding: "6px",
                        }}
                    >
                        <span
                            style={{
                                fontSize: "14px",
                                fontWeight: "500",
                                color: "#23A4C4",
                                paddingRight: "6px",
                            }}
                        >
                            {holdUploadBody.uploadname}
                        </span>
                        <RxCross2
                            style={{ cursor: "pointer" }}
                            onClick={handleRemoveFile}
                        />
                    </div>
                ) : (
                    <>
                        <div
                            onClick={handleUploadClick}
                            className="alignCenter justifyCenter brdrRadius cursorPointer"
                            style={{
                                background: "#23A4C41A",
                                height: "75px",
                                width: "90px",
                            }}
                        >
                            <FiUpload style={{ color: "23A4C4", fontSize: "19px" }} />
                            <input type="file" ref={fileInputRef} style={{ display: "none" }} onChange={handleUploadFile} />
                        </div>
                        {error?.upload && <span style={{ color: "red", fontSize: "12px" }}>{error?.upload}</span>}
                    </>
                )}
                <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-end", paddingTop: "10px" }}>
                    <Button variant="outlined" size="small" onClick={handleCloseDialog} text={l.cancel} />
                    <Button text={l.save} size="small" variant="contained" style={{ color: "#fff" }} onClick={handleUploadCertificate} />
                </div>
            </div>
        </div>
    )
}

export default ProvisionalCertificate;

